export const OBJECT = Object.freeze({});
export const ARRAY = Object.freeze([]);
